import type { SimulationObjectiveChoice } from "./sim-objective.types";

// Extraído de `sim-sandbox.types.ts` ao cruzar o teto de 200 linhas efetivas
// (guardrail #1). Concern próprio: traduzir a última execução persistida de volta para a escolha
// de objetivo da tela.

/**
 * A execução de onde a escolha é reconstituída — o detalhe do cenário (`lastRun`) e o próprio lote
 * (`AutoBatchResponse`) servem, porque a pergunta respondida está gravada nos dois.
 */
export interface AnsweredRun {
  objective: string;
  targetQuantity: number | null;
  productionOrderId: string | null;
  horizonHours: number;
}

/** Reconstitui a escolha de objetivo a partir da execução. */
export function objectiveFromLastRun(
  lastRun: AnsweredRun | null | undefined
): SimulationObjectiveChoice | null {
  if (!lastRun) return null;
  switch (lastRun.objective) {
    case "OEE_IMPROVEMENT":
      return { kind: "OEE_IMPROVEMENT", window: { hours: lastRun.horizonHours } };
    case "TARGET_QUANTITY":
      return {
        kind: "TARGET_QUANTITY",
        window: { hours: lastRun.horizonHours },
        ...(lastRun.targetQuantity ? { minQuantity: lastRun.targetQuantity } : {}),
      };
    case "TIME_TO_QUANTITY":
      return { kind: "TIME_TO_QUANTITY", quantity: lastRun.targetQuantity ?? Number.NaN };
    case "OP_ON_TIME":
      return { kind: "OP_ON_TIME", productionOrderId: lastRun.productionOrderId };
    default:
      // Objetivo de SEQUÊNCIA num lote de cenário não deveria existir; não inventa escolha.
      return null;
  }
}
